import React from 'react';
import CSSModules from 'react-css-modules';
import style from './badge.scss';

const Badge = ({ children, type }) => (
  <span className="Badge" styleName={`root type-${type}`}>
    {children}
  </span>
);

export default CSSModules(Badge, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/badge.js